import type {NativeWorkScope} from '../../protocol/native-envelope';
import type {SourceSceneSpecIntent,SourceSceneRetouchIntent} from '../SourceSceneSpecFields';
export type SourceSceneEditorBridge={scope:NativeWorkScope;revision:string;stage(intent:SourceSceneSpecIntent|SourceSceneRetouchIntent,mode:'regenerate'|'retouch'):Promise<void>};
let bridge:SourceSceneEditorBridge|null=null;
const listeners=new Set<()=>void>();
export const sourceSceneEditorBridge=()=>bridge;
export function subscribeSourceSceneEditor(callback:()=>void){listeners.add(callback);return()=>{listeners.delete(callback);};}
export function connectSourceSceneEditor(next:SourceSceneEditorBridge){bridge=next;for(const l of listeners)l();return()=>{if(bridge===next){bridge=null;for(const l of listeners)l();}};}
